module.exports = __webpack_public_path__ + "static/media/youtube.6c378143.svg";